<template>
  <div class="col-xs-12">
    <div class="col-xs-12">
      <div class="box-body form-center">
        <div>
          <h4 v-if="activity.strategy_data.rule_code === 'SA00001'">消費金額滿額</h4>
          <h4 v-else-if="activity.strategy_data.rule_code === 'SA00002'">消費商品數量滿額</h4>
          <h4 v-else-if="activity.strategy_data.rule_code === 'SA00003'">指定商品滿額</h4>
        </div>
      </div>
      <div class="box-body form-center">
        <!-- setting start-->
        <div v-if="activity.strategy_data.rule_code === 'SA00001'">
          <div class="input-group">
            <span class="input-group-addon">贈送條件達成金額</span>
            <span class="form-control form-info">{{activity.strategy_data.setting.money_unit}} 元</span>
          </div>
          <br />
        </div>
        <div v-if="activity.strategy_data.rule_code === 'SA00002' || activity.strategy_data.rule_code === 'SA00003'">
          <div class="input-group">
            <span class="input-group-addon">贈送條件達成商品數</span>
            <span class="form-control form-info">{{activity.strategy_data.setting.amount_unit}} 個</span>
          </div>
          <br />
        </div>
        <div v-if="activity.strategy_data.rule_code === 'SA00002'">
          <div class="input-group">
            <span class="input-group-addon">商品限制最低單價</span>
            <span class="form-control form-info">{{activity.strategy_data.setting.lowest_unit_price}} 元</span>
          </div>
          <br />
        </div>
        <div v-if="activity.strategy_data.setting.max_count">
          <div class="input-group">
            <span class="input-group-addon">每次贈送最大份數</span>
            <span class="form-control form-info">{{activity.strategy_data.setting.max_count}}</span>
          </div>
          <br />
        </div>
        <!-- setting end-->
      </div>
    </div>
    <div class="col-xs-12">
      <hr class="box-body">
      <div class="box-body form-center">
        <div>
          <h4>限制規則</h4>
        </div>
      </div>
      <div class="box-body form-left">
        <div v-if="showNoLimit">
          不限制
          <br><br>
        </div>
        <div v-if="activity.strategy_data.limit.order_type.length">
          <div class="input-group">
            <span class="input-group-addon">
              訂單類型
            </span>
            <div class="form-control form-info">
              <label class="label-success label m-r-5" v-for="ot in activity.strategy_data.limit.order_type">{{ot.label}}</label>
            </div>
          </div>
          <br>
        </div>
        <div v-if="activity.strategy_data.limit.order_method.length">
          <div class="input-group">
            <span class="input-group-addon">
              訂單方案
            </span>
            <div class="form-control form-info">
              <label class="label-success label m-r-5" v-for="om in activity.strategy_data.limit.order_method">{{om.label}}</label>
            </div>
          </div>
          <br>
        </div>
        <div v-if="activity.strategy_data.limit.min_total_paid_money">
          <div class="input-group">
            <span class="input-group-addon">訂單最低應付金額(單位：元)</span>
            <span class="form-control form-info">{{activity.strategy_data.limit.min_total_paid_money}}</span>
          </div>
          <br />
        </div>
        <div v-if="activity.strategy_data.limit.min_total_money">
          <div class="input-group">
            <span class="input-group-addon">訂單最低總金額(單位：元)</span>
            <span class="form-control form-info">{{activity.strategy_data.limit.min_total_money}}</span>
          </div>
          <br />
        </div>
        <div v-if="activity.strategy_data.limit.min_total_amount">
          <div class="input-group">
            <span class="input-group-addon">訂單最低購買數(單位：個)</span>
            <span class="form-control form-info">{{activity.strategy_data.limit.min_total_amount}}</span>
          </div>
          <br />
        </div>
      </div>
      <div class="box-body form-right">
        <div v-if="activity.strategy_data.limit.delivery_type.length">
          <div class="input-group">
            <span class="input-group-addon">
              取貨方式
            </span>
            <div class="form-control form-info">
              <label class="label-success label m-r-5" v-for="dt in activity.strategy_data.limit.delivery_type">{{dt.label}}</label>
            </div>
          </div>
          <br>
        </div>
        <div v-if="activity.strategy_data.limit.pay_place_type.length">
          <div class="input-group">
            <span class="input-group-addon">
              付款地點
            </span>
            <div class="form-control form-info">
              <label class="label-success label m-r-5" v-for="pt in activity.strategy_data.limit.pay_place_type">{{pt.label}}</label>
            </div>
          </div>
          <br>
        </div>
        <div v-if="activity.strategy_data.limit.min_money">
          <div class="input-group">
            <span class="input-group-addon">限制主單(或團長)最低總金額</span>
            <span class="form-control form-info">{{activity.strategy_data.limit.min_money}} 元</span>
          </div>
          <br />
        </div>
        <div v-if="activity.strategy_data.limit.min_amount">
          <div class="input-group">
            <span class="input-group-addon">限制主單(或團長)最低購買數</span>
            <span class="form-control form-info">{{activity.strategy_data.limit.min_amount}} 個</span>
          </div>
          <br />
        </div>
        <div v-if="activity.strategy_data.limit.min_sub_order_amount">
          <div class="input-group">
            <span class="input-group-addon">限制子單(跟團單)最低訂單數</span>
            <span class="form-control form-info">{{activity.strategy_data.limit.min_sub_order_amount}} 筆</span>
          </div>
          <br />
        </div>
      </div>
      <div v-if="activity.strategy_data.limit.min_paid_money" class="box-body form-center" style="padding-top: 0px">
        <div>
          <div class="input-group">
            <span class="input-group-addon">限制主單(或團長)最低應付金額(單位：元)</span>
            <span class="form-control form-info">{{activity.strategy_data.limit.min_paid_money}}</span>
          </div>
          <br />
        </div>
      </div>
    </div>
    <div class="col-xs-12">
      <hr class="box-body">
      <div class="box-body form-center" v-if="activity.strategy_data.store_exception_items[0].products.length || activity.strategy_data.setting.vendor_custom_product_list.length">
        <div style="margin-bottom: 20px">
          <h5 v-if="ruleCode === 'SA00001' || ruleCode === 'SA00002'">例外商品</h5>
          <h5 v-else>指定商品</h5>
        </div>
        <div class="m-t-10" v-if="activity.strategy_data.store_exception_items[0].products.length && (ruleCode === 'SA00001' || ruleCode === 'SA00002')">
          <table class="table table-bordered table-striped dataTable">
            <thead class="bg-primary">
            <tr>
              <td>＃</td>
              <td>商品</td>
              <td>商品料號</td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(aProduct, aIndex) in activity.strategy_data.store_exception_items[0].products">
              <td>
                {{aIndex + 1}}
              </td>
              <td>
                {{aProduct.product_name}}
              </td>
              <td>
                <div>{{aProduct.vendor_custom_id}}</div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="m-t-10" v-if="activity.strategy_data.setting.vendor_custom_product_list.length && ruleCode === 'SA00003'">
          <table class="table table-bordered table-striped dataTable">
            <thead class="bg-primary">
            <tr>
              <td>＃</td>
              <td>商品</td>
              <td>商品料號</td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(aProduct, aIndex) in activity.strategy_data.setting.vendor_custom_product_list">
              <td>
                {{aIndex + 1}}
              </td>
              <td>
                {{aProduct.product_name}}
              </td>
              <td>
                <div>{{aProduct.vendor_custom_id}}</div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import menuDiscount from '../../Discount/Temp/MenuDiscountTemp.vue'
export default {
  components: {
    'menu-discount': menuDiscount
  },
  props: {
    activity: Object,
    info: Object,
    brandList: Array,
    addStoresSetting: Object,
    storeList: Array,
    aStoreOption: Array,
    setInfoTimes: Number
  },
  data () {
    return {
      ruleCode: '',
      payPlaceType: [
        {label: '線上結帳', value: 10},
        {label: 'POS店家結帳', value: 50}
      ],
      ruleCodeOptions: [
        {label: '商品數量', value: 'SA00001'},
        {label: '指定商品數量', value: 'SA00002'},
        {label: '商品金額', value: 'SA00003'}
      ],
      orderType: [
        {label: '一般單', value: 1},
        {label: '團購單', value: 2}
      ],
      orderMethod: [
        {label: '當日單', value: 1},
        {label: '預訂單', value: 2}
      ],
      deliveryType: [
        {label: '自取', value: 1},
        {label: '內用', value: 2},
        {label: '外送', value: 3},
        {label: '內用-桌邊掃碼', value: 21}
      ],
      dStrategy: {
        limit: {
          delivery_types: [],
          order_types: [],
          order_method: [],
          min_money: '',
          min_amount: ''
        },
        setting: {
          // SC0001
          one_max_amount: '', //
          ratio: 1,
          lowest_unit_price: 0,
          // SA00002
          vendor_custom_product_list: [],
          // SA00003
          money_unit: []
        },
        // SA00001、SA00002、SA00003
        store_exception_items: [
          {
            products: [],
            store_ids: []
          }
        ]
      },
      storeSelect: {label: '', value: '', brand_id: ''},
      menuSelect: {
        label: '',
        value: 0
      },
      tableIndex: 1,
      count: 20,
      menuList: []
    }
  },
  methods: {
    getOnlineMenu () {
      var self = this
      self.menuList = []
      let select = this.storeSelect
      var url = '/onlineMenu/list?page=' + this.tableIndex + '&size=' + this.count + '&brand_id=' + select.brand_id + '&store_id=' + select.value
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var mList = response.data.menu_list
          mList.forEach(function (menu, index) {
            var option = {label: menu.name, value: menu.id}
            self.menuList.push(option)
            if (index === 0) self.menuSelect = option
          })
          if (!mList.length) self.menuSelect = {label: '', value: ''}
          // console.log(self.menuSelect)
          // self.total = response.data.total
        }
      })
    },
    clickOption (option) {
      var self = this
      this.addStoresSetting.options = []
      self.curId = option.id
      if (self.curId) {
        self.$nextTick(function () {
          self.reSet++
          self.addStoresSetting.options = self.storeBrief
          self.getCurStoreClass()
        })
      }
    },
    getCurStoreClass () {
      this.addStoresSetting.choose = []
      var self = this
      var url = '/brand/' + this.brandSelect.value + '/storeClass/' + this.curId
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var classInfo = response.data.class
          classInfo.store_list.forEach(function (s) {
            self.addStoresSetting.choose.push(s.id)
            // console.log(self.addStoresSetting.choose)
            // console.log(s)
          })
        }
      })
    },
    setStore () {
      var self = this
      let stores = this.info.attend_stores
      // console.log(stores)
      if (stores.length) {
        stores[0].store_list.forEach(function (store) {
          self.addStoresSetting.choose.push(store.store_id)
        })
      }
    },
    addProdToList (addPInfo) {
      // console.log(addPInfo)
      var self = this
      var pInfo = this.activity.strategy_data.setting.vendor_custom_product_list
      addPInfo.forEach(function (addP) {
        var isSame = pInfo.find(function (prod) {
          return addP.vendor_custom_id === prod.vendor_custom_id
        })
        if (!isSame) pInfo.push(addP)
        else {
          self.$notify({
            title: '提醒',
            text: addP.product_name + '已加入過',
            duration: 3000,
            width: 400
          })
        }
      })
    },
    addExProdToList (addPInfo) {
      var self = this
      var pInfo = this.activity.strategy_data.store_exception_items[0].products
      // console.log(this.activity.strategy_data)
      addPInfo.forEach(function (addP) {
        var isSame = pInfo.find(function (prod) {
          return addP.vendor_custom_id === prod.vendor_custom_id
        })
        if (!isSame) {
          pInfo.push(addP)
        } else {
          self.$notify({
            title: '提醒',
            text: addP.product_name + '已加入過',
            duration: 3000,
            width: 400
          })
        }
      })
    },
    addExProdToList2  (addPInfo) {
      var self = this
      var pInfo = this.activity.strategy_data.store_exception_items[0].products
      addPInfo.forEach(function (addP) {
        var isSame = pInfo.find(function (prod) {
          return addP.vendor_custom_id === prod.vendor_custom_id
        })
        if (!isSame) pInfo.push(addP)
        else {
          self.$notify({
            title: '提醒',
            text: addP.product_name + '已加入過',
            duration: 3000,
            width: 400
          })
        }
      })
    },
    removeListItem (list, index) {
      list.splice(index, 1)
    },
    returnNum (e) {
      var charCode = (e.which) ? e.which : e.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        e.preventDefault()
      } else {
        return true
      }
    },
    setInfo () {
      const self = this
      // console.log('aLimit', this.activity.strategy_data)
      // console.log('iLimit', this.info.strategy_data)
      let aLimit = this.activity.strategy_data.limit
      let iLimit = this.info.strategy_data.limit
      // order_type
      if (iLimit.order_type) {
        iLimit.order_type.forEach(function (orderType) {
          const otop = self.orderType.find(function (ot) { return ot.value === orderType })
          aLimit.order_type.push(otop)
        })
      }
      // order_method
      if (iLimit.order_method) {
        iLimit.order_method.forEach(function (orderMethod) {
          const omop = self.orderMethod.find(function (om) { return om.value === orderMethod })
          aLimit.order_method.push(omop)
        })
      }
      // delivery_type
      if (iLimit.delivery_type) {
        iLimit.delivery_type.forEach(function (deliveryType) {
          const dtop = self.deliveryType.find(function (dt) { return dt.value === deliveryType })
          aLimit.delivery_type.push(dtop)
        })
      }
      // pay_place_type
      if (iLimit.pay_place_type) {
        iLimit.pay_place_type.forEach(function (payPlaceType) {
          const pptop = self.payPlaceType.find(function (ppt) { return ppt.value === payPlaceType })
          aLimit.pay_place_type.push(pptop)
        })
      }
      // store_exception_items
      if (this.info.strategy_data.store_exception_items[0]) {
        this.info.strategy_data.store_exception_items[0].products.forEach(function (prod) {
          const obj = {product_name: prod.name, vendor_custom_id: prod.vendor_custom_id}
          self.activity.strategy_data.store_exception_items[0].products.push(obj)
        })
      }
      // vendor_custom_product_list
      if (this.info.strategy_data.setting.vendor_custom_product_list) {
        this.info.strategy_data.setting.vendor_custom_product_list.forEach(function (prod) {
          const o = {product_name: prod.name, vendor_custom_id: prod.id}
          self.activity.strategy_data.setting.vendor_custom_product_list.push(o)
        })
      }
    }
  },
  created () {
    if (this.$route.query.rule_code) this.ruleCode = this.$route.query.rule_code
    else if (this.info.info.rule_code) this.ruleCode = this.info.info.rule_code
  },
  computed: {
    getDataH () {
      return this.$parent.getDataH
    },
    showNoLimit () {
      const activity = this.activity
      if (!activity.strategy_data.limit.order_type.length &&
        !activity.strategy_data.limit.order_method.length &&
        !activity.strategy_data.limit.min_total_paid_money &&
        !activity.strategy_data.limit.min_total_money &&
        !activity.strategy_data.limit.min_total_amount &&
        !activity.strategy_data.limit.delivery_type.length &&
        !activity.strategy_data.limit.pay_place_type.length &&
        !activity.strategy_data.limit.min_money &&
        !activity.strategy_data.limit.min_amount &&
        !activity.strategy_data.limit.min_sub_order_amount &&
        !activity.strategy_data.limit.min_paid_money) {
        return true
      }
      return false
    }
  },
  watch: {
    'storeSelect.value' () {
      if (this.storeSelect.value) {
        this.getOnlineMenu()
      }
    },
    setInfoTimes () {
      this.ruleCode = this.info.info.rule_code
      this.setInfo()
    }
  }
}
</script>
<style lang="sass" scoped>
  .un-active
    opacity: .3
</style>



// WEBPACK FOOTER //
// ActivityStrategyInfo.vue?8fbf008a